export const ReviewCompletionTimeGraph = () => {
  return <div>Coming soon</div>;
};
